import type { MarketDraft } from "./types";

export function validateRecruitment(input: { organizerAge: number; participantAge: number; venue: "public" | "private"; guardianPresent: boolean }): string[] {
  const errors: string[] = [];
  if (![input.organizerAge, input.participantAge].every(age => Number.isInteger(age) && age >= 14 && age <= 120)) errors.push("주최자와 참여자의 실제 나이를 확인해 주세요.");
  const hasMinor = input.organizerAge < 19 || input.participantAge < 19;
  const adultMinorPair = (input.organizerAge >= 19) !== (input.participantAge >= 19);
  if (hasMinor && input.venue === "private") errors.push("미성년자가 포함된 비공개 장소 모집은 만들 수 없어요.");
  if (adultMinorPair && !input.guardianPresent) errors.push("성인·미성년 조합은 보호자 또는 행사 운영 동행이 필요해요.");
  return errors;
}

export function validateMarketDraft(draft: Pick<MarketDraft, "kind" | "title" | "priceKrw" | "sizeOrScope" | "condition">): string[] {
  const errors: string[] = [];
  if (draft.title.trim().length < 4) errors.push("작품·캐릭터·품목이 읽히는 제목을 적어주세요.");
  if (draft.priceKrw < 0) errors.push("가격은 0원 이상이어야 해요.");
  if (draft.sizeOrScope.trim().length < 2) errors.push("실측 또는 제작 범위를 적어주세요.");
  if (draft.condition.trim().length < 2) errors.push("오염·수선·구성품 상태를 적어주세요.");
  if (/r\s*18|성인|티켓|입장권|계정/i.test(draft.title)) errors.push("R18, 티켓 재판매, 계정 거래는 지원하지 않아요.");
  return errors;
}

